import { render, staticRenderFns } from "./PurchaseItemList.vue?vue&type=template&id=6694f00a&scoped=true&"
import script from "./PurchaseItemList.vue?vue&type=script&lang=js&"
export * from "./PurchaseItemList.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseItemList.vue?vue&type=style&index=0&id=6694f00a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6694f00a",
  null
  
)

export default component.exports